[
  { "name": "Razorpay", "file": "razorpay.svg" },
  { "name": "Zerodha", "file": "zerodha.svg" },
  { "name": "Flipkart", "file": "flipkart.svg" },
  { "name": "Swiggy", "file": "swiggy.svg" },
  { "name": "PhonePe", "file": "phonepe.svg" },
  { "name": "Infosys", "file": "infosys.svg" },
  { "name": "Wipro", "file": "wipro.svg" },
  { "name": "TCS", "file": "tcs.svg" }
]
